import { AdminTableListResponse } from "admin/types/interfaces/adminTable";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Number of tables requested in a single call. The admin endpoint caps `limit`
 * at 10000; 5000 is a best-effort ceiling to load a schema's tables at once so
 * the table dropdown can filter client-side. When the total exceeds this,
 * callers should surface `metadata.has_more` rather than silently dropping tables.
 */
export const ADMIN_TABLES_LIMIT = 5000;

/**
 * Lists the tables in `schema`. The admin endpoint requires a schema, so no
 * request is made until one is chosen (SWR receives a null key).
 */
const useAdminTables = (schema: string | null) => {
  const url = schema
    ? `${VITE_CATALOG_API}/admin/tables?schema=${encodeURIComponent(schema)}&offset=0&limit=${ADMIN_TABLES_LIMIT}`
    : null;

  const { data, error, isLoading } = useFetcher<AdminTableListResponse>(url);

  return {
    items: data?.items ?? [],
    metadata: data?.metadata,
    isLoading,
    error,
  };
};

export default useAdminTables;
